import React from "react";
import "./LandingPage.css";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div className="lp" data-testid="landing-page">
      {/* Nav */}
      <nav className="lp-nav" data-testid="lp-nav">
        <a href="/" className="lp-nav-logo">ILIK</a>
        <div className="lp-nav-right">
          <a href="/app?login=true" className="lp-nav-login">Log in</a>
          <a href="/waitlist" className="lp-nav-cta">Join Waitlist</a>
        </div>
      </nav>

      {/* Hero */}
      <section className="lp-hero" data-testid="lp-hero">
        <h1>A new way to understand your body.</h1>
        <p>ILIK maps your cycle into 4 seasons. Each season has a different vibe, ILIK helps you plan with it.</p>
        <a href="/waitlist" className="lp-btn-white" data-testid="lp-hero-cta">Join Our Waitlist</a>
      </section>

      {/* Middle Section */}
      <section className="lp-section lp-section-alt" data-testid="lp-middle">
        <div className="lp-section-inner">
          <h2 className="lp-headline">Your hormones change every week. Your capacity changes with them.</h2>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta-section" data-testid="lp-cta">
        <h2>Understanding your cycle is understanding yourself.</h2>
        <p>ILIK helps you notice your patterns and plan around them.</p>
        <a href="/waitlist" className="lp-btn-white" data-testid="lp-cta-btn">Join Our Waitlist</a>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
